import { Search } from "@components/global/new/Search/Search";
import { Select } from "@components/global/new/Select/Select";
import Status from "@components/global/new/Status/Status";
import { MINER_STATUSES_E } from "@constants/MinerStatuses";
import classNames from "classnames";
import { useState } from "react";
import { useIntl } from "react-intl";
import styles from "./Filters.module.scss";

const StatusOrder: (keyof typeof MINER_STATUSES_E)[] = [
  "OK",
  "LOW",
  "BAD",
  "OFF",
  "STARTING",
  "PAUSED",
  "STOPPED",
  "FAIL",//"CONNECTION_ERROR",
];

type Filter3Props = {
  onSearch(s: string, filter?: string): void;
};

const Filters3 = (props: Filter3Props) => {
  const { formatMessage } = useIntl();
  const [search, setSearch] = useState<string>();
  const [filt, setFilt] = useState<string>()

  return <div className={styles.filters}>
    <Select
      label={formatMessage({ id: "state_selector.label.state" })}
      allowClear
      onClear={() => {
        setFilt(undefined);
        props.onSearch(search ?? "");
      }}
      onChange={(f: string) => {
        setFilt(f);
        props.onSearch(search ?? "", f);
      }}
      optionRender={item => {
        const label = item.label as keyof typeof MINER_STATUSES_E;
        return (
          <div className={styles.optionState}>
            <Status status={MINER_STATUSES_E[label]} className={classNames({
              [styles.icon]: label.length < 4,
              [styles.status]: label.length > 3,
            })} />
            {label.length < 4 && <p>{label}</p>}
          </div>
        );
      }}
      options={StatusOrder.map(item => ({
        label: item,
        value: item,
      }))}
    />
    <Search
      allowClear
      placeholder={formatMessage({ id: "general.search" })}
      onClear={() => setSearch(undefined)}
      onSearch={(s) => {
        setSearch(s);
        props.onSearch(s, filt);
      }}
      onChange={(e) => setSearch(e.target.value)}
    />
  </div>
}

export default Filters3;
